/**
 * Höjer levererad upplösning för produktkort (särskilt Retina / stora rutor).
 * Påverkar bara kända mönster; övriga URL:er lämnas orörda.
 */
export function productCardImageUrl(raw) {
  if (!raw || typeof raw !== 'string') return raw;

  if (raw.includes('res.cloudinary.com') && raw.includes('/image/upload/')) {
    const prefix = '/image/upload/';
    const at = raw.indexOf(prefix);
    if (at === -1) return raw;
    const head = raw.slice(0, at + prefix.length);
    const tail = raw.slice(at + prefix.length);
    const firstSlash = tail.indexOf('/');
    const firstSeg = firstSlash === -1 ? tail : tail.slice(0, firstSlash);
    const rest = firstSlash === -1 ? '' : tail.slice(firstSlash);

    if (/\bw_\d+/.test(firstSeg)) {
      const bumped = firstSeg.replace(/\bw_\d+/, 'w_1200');
      return head + bumped + rest;
    }
    return `${head}w_1200,q_auto:best,f_auto/${tail}`;
  }

  if (raw.includes('images.unsplash.com')) {
    return raw.replace(/([?&])w=\d+/i, '$1w=1200');
  }

  return raw;
}
